import React, { useEffect, useState } from "react";
import "./styles.css";
import { Button, Form, OverlayTrigger, Popover } from "react-bootstrap";

interface MultiSelectorProps {
    dataOptions: any[];
    currentSelected: any[];
    onChange: (data: any[]) => void;
    title: string;
}

const MultiSelector: React.FC<MultiSelectorProps> = (props: MultiSelectorProps) => {
    const [currentSelected, setCurrentSelected] = useState<any[]>(props.currentSelected);
    const [show, setShow] = useState(false);

    const handleShowSelectYearAndQuarter = () => {
        setShow(!show);
    };

    useEffect(() => {
        props.onChange(props.currentSelected);
    }, [props.currentSelected]);

    const onChangeSelector = (value: any) => {
        const existingValue = currentSelected.find((q) => q === value);

        if (existingValue) {
            const updatedValue = currentSelected.filter((q) => q !== value);
            props.onChange(updatedValue);
            setCurrentSelected(updatedValue);
        } else {
            const updatedValue = [...currentSelected, value];
            setCurrentSelected(updatedValue);
            props.onChange(updatedValue);
        }
    };

    const onSelectAll = () => {
        const allValues = props.dataOptions;
        if (currentSelected.length === allValues.length) {
            props.onChange([]);
            setCurrentSelected([]);
            return;
        } else {
            props.onChange(allValues);
            setCurrentSelected(allValues);
        }
    };

    const renderPopover = (
        <Popover id="popover-contained">
            <Popover.Header as="h3"> Select Year And Quarter:</Popover.Header>
            <Popover.Body>
                <Form.Check label={`Select all`} onChange={() => onSelectAll()} checked={currentSelected.length === props.dataOptions.length} />
                {props.dataOptions.map((data) => {
                    return <Form.Check key={data} label={data} onChange={() => onChangeSelector(data)} checked={currentSelected.includes(data)} />;
                })}
            </Popover.Body>
        </Popover>
    );

    return (
        <div className="selector-container">
            <OverlayTrigger show={show} placement="bottom" containerPadding={20} overlay={renderPopover}>
                <Button onClick={handleShowSelectYearAndQuarter}>{props.title}</Button>
            </OverlayTrigger>
        </div>
    );
};

export default MultiSelector;
